import { lazy } from "react";
import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

const SuppliersListPage = lazy(() =>
  import("@/pages/suppliers").then((m) => ({ default: m.SuppliersListPage }))
);
const SupplierDetailPage = lazy(() =>
  import("@/pages/suppliers").then((m) => ({ default: m.SupplierDetailPage }))
);
const SupplierEvaluationsPage = lazy(() =>
  import("@/pages/suppliers/evaluations/supplier-evaluations-page").then((m) => ({ default: m.SupplierEvaluationsPage }))
);
const SupplierEvaluationDetailPage = lazy(() =>
  import("@/pages/suppliers/evaluations/supplier-evaluation-detail-page").then((m) => ({ default: m.SupplierEvaluationDetailPage }))
);
const SupplierTypesPage = lazy(() =>
  import("@/pages/suppliers/types/supplier-types-page").then((m) => ({ default: m.SupplierTypesPage }))
);
const SupplierTypeDetailPage = lazy(() =>
  import("@/pages/suppliers/types/supplier-type-detail-page").then((m) => ({ default: m.SupplierTypeDetailPage }))
);
const CertificateTemplatesPage = lazy(() =>
  import("@/pages/suppliers/certificate-templates/certificate-templates-page").then((m) => ({ default: m.CertificateTemplatesPage }))
);
const ScoringRulesPage = lazy(() =>
  import("@/pages/suppliers/scoring-rules-page").then((m) => ({ default: m.ScoringRulesPage }))
);

const SUPPLIER_READ = { access: "permission" as const, entity: "suppliers", action: "READ" };
const SUPPLIER_EVAL_READ = { access: "permission" as const, entity: "supplier_evaluations", action: "READ" };

export const supplierRoutes: RouteConfig[] = [
  { path: ROUTES.SUPPLIERS.LIST, component: SuppliersListPage, layout: "dashboard", permissions: SUPPLIER_READ },
  // Specific routes BEFORE :supplierId catch-all so React Router matches them first
  { path: ROUTES.SUPPLIERS.EVALUATIONS, component: SupplierEvaluationsPage, layout: "dashboard", permissions: SUPPLIER_EVAL_READ },
  { path: ROUTES.SUPPLIERS.EVALUATION_DETAIL, component: SupplierEvaluationDetailPage, layout: "dashboard", permissions: SUPPLIER_EVAL_READ },
  { path: ROUTES.SUPPLIERS.TYPES, component: SupplierTypesPage, layout: "dashboard", permissions: SUPPLIER_EVAL_READ },
  { path: ROUTES.SUPPLIERS.TYPE_DETAIL, component: SupplierTypeDetailPage, layout: "dashboard", permissions: SUPPLIER_EVAL_READ },
  { path: ROUTES.SUPPLIERS.CERTIFICATE_TEMPLATES, component: CertificateTemplatesPage, layout: "dashboard", permissions: SUPPLIER_EVAL_READ },
  { path: ROUTES.SUPPLIERS.SCORING_RULES, component: ScoringRulesPage, layout: "dashboard", permissions: SUPPLIER_EVAL_READ },
  { path: ROUTES.SUPPLIERS.DETAIL, component: SupplierDetailPage, layout: "dashboard", permissions: SUPPLIER_READ },
];
